handlePlansLocalized